/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignBoxRightTop = createReactComponent("outline", "align-box-right-top", "IconAlignBoxRightTop", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 13h2", "key": "svg-1" }], ["path", { "d": "M11 10h6", "key": "svg-2" }], ["path", { "d": "M13 7h4", "key": "svg-3" }]]);

export { IconAlignBoxRightTop as default };
//# sourceMappingURL=IconAlignBoxRightTop.mjs.map
